export class LengthValidationRule {
    // #region Vars
    name = 'len';
    // #endregion
    // #region Core
    validate(field, rule, value, object) {
        let tMin = rule.props.minlen;
        let tMax = rule.props.maxlen;
        //Data
        if (value === undefined || value === null) {
            return { isValid: true };
        }
        if (/(string|array)/.test(typeof value) === false) {
            return { isValid: false, message: "Ungültiger Eingabe-Wert" };
        }
        if (tMin > 0 && tMax > 0 && value.length > 0 && tMax === tMin) {
            if (value.length !== tMax) {
                return { isValid: false, message: host.localizer?.tc('system.Validation.StringLengthExact', [field.displayName, tMax, tMin]) };
            }
            else {
                return { isValid: true };
            }
        }
        else if (tMin > 0 && tMax > 0 && value.length > 0 && (value.length > tMax || value.length < tMin)) {
            return { isValid: false, message: host.localizer?.tc('system.Validation.StringLengthMinMax', [field.displayName, tMax, tMin]) };
        }
        else if (tMax > 0 && value.length > 0 && (value.length > tMax)) {
            return { isValid: false, message: host.localizer?.tc('system.Validation.StringLengthMax', [field.displayName, tMax, '']) };
        }
        else if (tMin > 0 && value.length > 0 && (value.length < tMin)) {
            return { isValid: false, message: host.localizer?.tc('system.Validation.StringLengthMin', [field.displayName, '', tMin]) };
        }
        return { isValid: true };
    }
}
